module.exports = __webpack_public_path__ + "img/classic_2.a0aaa4f9.png";